//多项目共用一套程序的皮肤解决方案
import SkinPlugin from '@/../../plugins/skin.js';
import skinLib from '@/lib/skin.js';
SkinPlugin.set({skinLib /*,mulit:false*//*三种只匹配一种*/ });
//SkinPlugin.set({skinLib,auto:false}); //不自动匹配
//SkinPlugin.load("localhost","4008-197-197.com"); //手动设置
import Vue from 'vue';
import Com from './Com.js';

//一些特殊情况可能会用到
//比如浏览器设置访客模式致使localStorage失效,需用cookie替代
//不用到可不用
import VueCookies from 'vue-cookies'


Vue.use(VueCookies);
window.Com = Com; 
window.debug = false; //是否本地环境
if(!window.currency) {
	window.currency = ''
}
window.standardDB = true; //是否正式库数据
console.log(window.location.hostname, 999)
if(window.location.hostname == 'localhost'
	|| window.location.hostname == '127.0.0.1'
	|| window.location.hostname.indexOf('10.200.102') > -1
	|| window.location.hostname.indexOf('qc.') > -1
	|| window.location.hostname.indexOf('saasv6_beta.') > -1  // beta 环境
){
	window.debug = true;
	window.standardDB = false;
}
//全局混入
Vue.mixin({
	data(){
		return {
			//全局公用不缓存
		}
	}
	,created(){
		// this.$nextTick( () => {
    //
		// })
	}
	,mounted(){

	}
	,methods:{
		back(){ //返回上一页
			this.$router.back();
		}
	}
});

Math.add = function(arg1, arg2) {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (Math.mul(arg1 , m) + Math.mul(arg2 , m)) / m;
}

Math.sub = function(arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    // 动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((Math.mul(arg1 , m) - Math.mul(arg2 , m)) / m).toFixed(n);
}

Math.mul = function(arg1, arg2) {
    if(arg1 == null || arg2 == null){
        return null;
    }
    var n1,n2;
    var r1, r2; // 小数位数
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    n1 = Number(arg1.toString().replace(".", ""));
    n2 = Number(arg2.toString().replace(".", ""));
    return n1 * n2 / Math.pow(10, r1+r2);
}

Math.div = function(arg1, arg2) {
    if(arg1 == null){
        return null;
    }
    if(arg2 == null || arg2 == 0){
        return null;
    }
    var n1,n2;
    var r1, r2; // 小数位数
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    n1 = Number(arg1.toString().replace(".", ""));
    n2 = Number(arg2.toString().replace(".", ""));
    return (n1 / n2) * Math.pow(10, r2 - r1);
}



// WEBPACK FOOTER //
// ./plugins/init.js